<template>
  <div class="other-income">
    <div class="other-income-container">
      <el-select class="white" v-model="warehouseId" placeholder="请选择仓库">
        <el-option
          v-for="item in warehouse"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-upload
        :disabled="warehouseId ? false : true"
        v-loading.fullscreen.lock="loading"
        element-loading-text="文件上传中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        class="upload"
        ref="upload"
        action="#"
        :show-file-list="false"
        :auto-upload="true"
        :before-upload="uploadExcel"
      >
        <el-button slot="trigger" class="btn-blue" @click="watch"
          >收入上传</el-button
        >
      </el-upload>
      <a class="load-btn btn-blue" :href="tplHref" download>下载模板</a>
    </div>
  </div>
</template>

<script>
import Expenses from "models/expenses";
import RentalIncome from "models/rental-income";
const expenses = new Expenses();
const rentalIncome = new RentalIncome();
const tplHref =
  "https://ydb-kz.oss-cn-hangzhou.aliyuncs.com/%E5%85%B6%E4%BB%96%E6%94%B6%E5%85%A5--%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";
export default {
  data() {
    return {
      tplHref,
      warehouseId: "",
      warehouse: [],
      loading: false
    };
  },
  created() {
    this.getWarehouse();
  },
  methods: {
    //获取仓库数据
    getWarehouse() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouse = arr;
        }
      });
    },
    watch() {
      if (!this.warehouseId) {
        this.$message.error("请选择仓库");
      }
    },
    //导入Excel表格
    uploadExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      formData.append("warehouseId", this.warehouseId);
      this.loading = true;
      rentalIncome
        .postOtherIncomeExcel(formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.loading = false;
          } else {
            this.loading = false;
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(res => {
          console.log(res);
          this.$message.error("导入失败");
          this.loading = false;
        });
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
.other-income {
  flex: 1;
  display: flex;
  flex-direction: column;
  .other-income-container {
    flex: 1;
    background: #fff;
    border-radius: 4px;
    display: flex;
    padding: 16px;
    align-items: flex-start;
    .load-btn {
      margin-left: 20px;
      width: 102px;
      height: 32px;
      background-color: #2e68ea;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #fff;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .btn-blue {
    margin-left: 16px;
  }
}
</style>
